import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
	CurrencyCode,
	DepartmentPayrollCurrencyUpdateResponse
} from '../../../models/payroll-currency.model';
import {
	MorningOvertimeHeadSetting,
	MorningOvertimeHeadSettingUpdateRequest
} from '../../common/morning-overtime-readiness/models/morning-overtime-readiness.model';
import { MorningOvertimeReadinessApiService } from '../../common/morning-overtime-readiness/services/morning-overtime-readiness-api.service';
import { ViewGroupPayrollCurrencyPort } from './view-group-payroll-currency.port';

@Injectable()
export class ViewGroupSettingsApi {
	constructor(
		private morningOvertimeApi: MorningOvertimeReadinessApiService,
		private payrollCurrencyApi: ViewGroupPayrollCurrencyPort
	) {}

	loadMorningOvertime(groupId: string): Observable<MorningOvertimeHeadSetting> {
		return this.morningOvertimeApi.getHeadSetting(groupId);
	}

	updateMorningOvertime(
		groupId: string,
		request: MorningOvertimeHeadSettingUpdateRequest
	): Observable<MorningOvertimeHeadSetting> {
		return this.morningOvertimeApi.updateHeadSetting(groupId, request);
	}

	updatePayrollCurrency(
		groupId: string,
		currency: CurrencyCode
	): Observable<HttpResponse<DepartmentPayrollCurrencyUpdateResponse>> {
		return this.payrollCurrencyApi.update(groupId, currency);
	}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/view-group-settings.api.ts